import { render, staticRenderFns } from "./labelWidth-editor.vue?vue&type=template&id=b8855d4a&scoped=true&"
import script from "./labelWidth-editor.vue?vue&type=script&lang=js&"
export * from "./labelWidth-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8855d4a",
  null
  
)

export default component.exports